import React, { useEffect } from "react";
import { getAgentCoreChatConfig } from "../../constants/appConstants";
import * as AgentCoreChatService from "../../services/agentCoreChatService";
import { getDomainLocation } from "../../util/util";
import { logError, logWarn } from "../../util/logger";

const AgentCoreChat = ({ locale }) => {
  useEffect(() => {
    const config = getAgentCoreChatConfig(getDomainLocation(), locale);

    if (!AgentCoreChatService.validateConfig(config)) {
      logWarn("AgentCoreChat: Missing required configuration. Chat widget will not load.");
      return;
    }

    AgentCoreChatService.initializeWidget(config).catch((error) => {
      logError("AgentCoreChat: Widget initialization failed.", error);
    });

    return () => {
      AgentCoreChatService.destroyWidget();
    };
  }, [locale]);

  return null;
};

export default AgentCoreChat;
